module.exports = __webpack_public_path__ + "src/assets/img/06_5art_3part.8c327ee8.jpg";